import authentication from '@/utils/auth'

const user = {
  state: {
    token: '',
    id: '',
    username: '',
    name: '',
    email: '',
    microsoft_id: '',
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
    roles: [],
    authenticated: false
  },
  getters: {
    getToken(state) {
      return state.token
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_MICROSOFT_ID: (state, microsoft_id) => {
      state.microsoft_id = microsoft_id
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AUTHENTICATION: (state, authenticated) => {
      state.authenticated = authenticated
    },
    RESET_USER: (state) => {
      Object.assign(state, {
        token: '',
        id: '',
        username: '',
        name: '',
        email: '',
        microsoft_id: '',
        avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
        roles: [],
        authenticated: false
      })
    }
  },

  actions: {
    // 登录
    Login() {
      authentication.signIn()
    },

    // 获取用户信息
    async GetInfo() {
      return await authentication.getUserProfile()
    },

    // 登出
    LogOut() {
      authentication.signOut()
    },

    // 前端 登出
    FedLogOut({ commit }) {
      authentication.signOut()
    }
  }
}

export default user
